<template>
  <div class="flex flex-col h-full items-start md:items-center">
    <div class="flex flex-col text-center items-center justify-start m-0 mx-4 flex-1">
      <img
        :src="getIntegrationLogo"
        class="p-2 h-16 w-16"
      />
      <div>
        <h3 class="text-xl text-slate-800 dark:text-slate-100">
          {{ getIntegrationName }}
        </h3>
        <p style="white-space: pre-line;">{{
            useInstallationName(
              integrationDescription,
              globalConfig.installationName
            )
          }}</p>
      </div>
    </div>
    <div
      v-if="
        integrationId === 'openai' ||
        integrationId === 'mobile_app' ||
        integrationId === 'click_to_call' ||
        integrationId === 'doc_signature' ||
        integrationId === 'forms'
      "
    >
      <div
        v-if="hasConnectedHooks"
        class="flex justify-center items-center mb-0"
      >
        <woot-button
          v-if="integrationId !== 'doc_signature' && integrationId !== 'forms'"
          icon="edit"
          color-scheme="secondary"
          class="margin-horizontal-2"
          @click.prevent="onSettings"
        >
          {{ $t('COMMAND_BAR.SECTIONS.SETTINGS') }}
        </woot-button>
        <div
          v-if="hasDeletePermission('ChatGPT') && integrationId === 'openai'"
        >
          <div @click="openDeletePopupApp">
            <woot-button class="nice alert">
              {{ $t('INTEGRATION_APPS.DISCONNECT.BUTTON_TEXT') }}
            </woot-button>
          </div>
        </div>
        <div
          v-if="
            hasDeletePermission('Click2Call') &&
            integrationId === 'click_to_call'
          "
        >
          <div @click="openDeletePopupApp">
            <woot-button class="nice alert">
              {{ $t('INTEGRATION_APPS.DISCONNECT.BUTTON_TEXT') }}
            </woot-button>
          </div>
        </div>
        <div
          v-if="
            hasDeletePermission('Mobile App') && integrationId === 'mobile_app'
          "
        >
          <div @click="openDeletePopupApp">
            <woot-button class="nice alert">
              {{ $t('INTEGRATION_APPS.DISCONNECT.BUTTON_TEXT') }}
            </woot-button>
          </div>
        </div>
        <div
          v-if="
            hasDeletePermission('IntegrationDocal') &&
            integrationId === 'doc_signature'
          "
        >
          <div @click="openDeletePopupApp">
            <woot-button class="nice alert">
              {{ $t('INTEGRATION_APPS.DISCONNECT.BUTTON_TEXT') }}
            </woot-button>
          </div>
        </div>
        <div
          v-if="
            hasDeletePermission('IntegrationForms') && integrationId === 'forms'
          "
        >
          <div @click="openDeletePopupApp">
            <woot-button class="nice alert">
              {{ $t('INTEGRATION_APPS.DISCONNECT.BUTTON_TEXT') }}
            </woot-button>
          </div>
        </div>
      </div>
      <div v-else class="flex flex-row justify-center items-center mb-0">
        <woot-button
          v-if="
            integrationId === 'click_to_call' &&
            hasCreatePermission('Click2Call')
          "
          color-scheme="nice"
          @click.prevent="addApp"
        >
          {{
            customTexts.connectButtonCaption ||
            $t('INTEGRATION_APPS.CONNECT.BUTTON_TEXT')
          }}
        </woot-button>
        <woot-button
          v-if="
            (integrationId === 'openai' && hasCreatePermission('ChatGPT')) ||
            (integrationId === 'doc_signature' && hasCreatePermission('IntegrationDocal')) ||
            (integrationId === 'forms' && hasCreatePermission('IntegrationForms')) ||
            (integrationId !== 'openai' && integrationId !== 'click_to_call' && integrationId !== 'doc_signature' && integrationId !== 'forms')
          "
          color-scheme="success"
          @click.prevent="addApp"
        >
          {{
            customTexts.connectButtonCaption ||
            $t('INTEGRATION_APPS.CONNECT.BUTTON_TEXT')
          }}
        </woot-button>
      </div>
    </div>
    <div v-else class="flex justify-center items-center mb-0 w-[15%]">
      <router-link
        :to="
          frontendURL(
            `accounts/${accountId}/${integrationPath || 'settings/integrations'}/` + integrationId
          )
        "
      >
        <div v-if="integrationEnabled">
          <div v-if="integrationAction === 'disconnect'">
            <div @click="openDeletePopup">
              <woot-submit-button
                :button-text="
                  actionButtonText ||
                    $t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.BUTTON_TEXT')
                "
                button-class="smooth alert"
              />
            </div>
          </div>
          <div v-else>
            <button :disabled="disabled" class="button nice">
              {{ $t('INTEGRATION_SETTINGS.WEBHOOK.CONFIGURE') }}
            </button>
          </div>
        </div>
      </router-link>
      <div v-if="!integrationEnabled">
        <a :href="integrationAction" class="button success nice">
          {{ $t('INTEGRATION_SETTINGS.CONNECT.BUTTON_TEXT') }}
        </a>
      </div>
    </div>
    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="
        deleteConfirmationTextApp.title || deleteConfirmationText.title ||
          $t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.CONFIRM.TITLE')
      "
      :message="
        deleteConfirmationTextApp.message || deleteConfirmationText.message ||
          $t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.CONFIRM.MESSAGE')
      "
      :confirm-text= "customTexts.deleteYes ||  $t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.CONFIRM.YES')"
      :reject-text= "customTexts.deleteNo || $t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.CONFIRM.NO')"
    />

    <chat-gpt-enable-modal
      v-if="showChatGptEnableModal"
      :show="showChatGptEnableModal"
      @close="toggleChatGptEnableModal"
    />
    <doc-signature-enable-modal
      v-if="showDocSignatureEnableModal"
      :show="showDocSignatureEnableModal"
      @close="toggleDocSignatureEnableModal"
    />
    <forms-enable-modal
      v-if="showFormsEnableModal"
      :show="showFormsEnableModal"
      @close="toggleFormsEnableModal"
    />
    <woot-modal
      :show.sync="showDAssistanceSettings"
      :on-close="toggleDAssistanceShow"
    >
      <woot-modal-header
        :header-title="$t('D_ASSISTANCE.SETTINGS.TITLE')"
        :header-content="$t('D_ASSISTANCE.SETTINGS.NOTE')"
      />
      <digital99-assistance-setting
        v-if="showDAssistanceSettings"
        @cancel="toggleDAssistanceShow"
      />
    </woot-modal>

    <woot-modal
      :show.sync="showClick2CallSettings"
      :on-close="() => (showClick2CallSettings = false)"
    >
      <woot-modal-header
        :header-title="$t('CLICK2CALL_SETTINGS.SETTINGS.TITLE')"
        :header-content="$t('CLICK2CALL_SETTINGS.SETTINGS.NOTE')"
      />
      <click2-call-settings
        :show="showClick2CallSettings"
        @cancel="() => (showClick2CallSettings = false)"
      />
    </woot-modal>

  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import integration from './Integration.vue';
import hookMixin from '../integrationapps/hookMixin';
import ChatGptEnableModal from '../../../../components/widgets/digital99Assistance/ChatGptEnableModal.vue';
import DocSignatureEnableModal from '../../../../components/widgets/docSignature/DocSignatureEnableModal.vue';
import FormsEnableModal from '../../../../components/widgets/forms/FormsEnableModal.vue';
import Digital99AssistanceSetting from '../../../../components/widgets/digital99Assistance/Digital99AssistanceSetting.vue';
import Click2CallSettings from './Click2Call/Settings.vue';
import Click2CallSettingsAPI from '../../../../api/click2callSettings';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  components: {
    Digital99AssistanceSetting,
    ChatGptEnableModal,
    DocSignatureEnableModal,
    FormsEnableModal,
    Click2CallSettings,
  },
  mixins: [integration, hookMixin, hasPermissionMixin],
  props: {
    integration: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      showDAssistanceSettings: false,
      showChatGptEnableModal: false,
      showDocSignatureEnableModal: false,
      showFormsEnableModal: false,
      showClick2CallSettings: false,
      showClick2CallEnableModal: true,
      deleteConfirmationTextApp: { type: Object, default: () => ({}) },
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
    }),
    account() {
      return this.getAccount(this.accountId);
    },
    customTexts() {
      if (!this.integration.custom_texts) return {};
      const textPrefix = `INTEGRATION_APPS.CUSTOM_TEXTS.${this.integration.id.toUpperCase()}.`;
      return {
        connectButtonCaption: this.$t(textPrefix + 'ENABLE'),
        deleteMessage: this.$t(textPrefix + 'DELETE_MESSAGE'),
        deleteYes: this.$t(textPrefix + 'DELETE_YES'),
        deleteNo: this.$t(textPrefix + 'DELETE_NO'),
      };
    },
    iPracticomFeatures() {
      return this.account.platform_features?.iPracticom;
    },
    oneCityFeatures() {
      return this.account.platform_features?.one_city;
    },
    getIntegrationName() {
      let oldSubStr1 = '99 דיגיטל';
      let oldSubStr2 = '99digital';
      let newSubStr = null;
      if (this.iPracticomFeatures) {
        newSubStr = 'iPracticom';
      } else if (this.oneCityFeatures) {
        newSubStr = 'One City';
      }
      if (newSubStr) {
        return this.integrationName.replace(
          new RegExp(`${oldSubStr1}|${oldSubStr2}`, 'gi'),
          newSubStr
        );
      }
      return this.integrationName;
    },
    getIntegrationLogo() {
      if (this.integrationId === 'openai' && this.iPracticomFeatures) {
        return '/dashboard/images/integrations/ipracticom.jpg';
      }
      return '/dashboard/images/integrations/' + this.integrationLogo;
    },
  },
  mounted() {
    console.log('IntegrationExt99 mounted with integration:', this.integrationId);
    console.log('Has ChatGPT delete permission:', this.hasDeletePermission('ChatGPT'));
  },
  methods: {
    toggleChatGptEnableModal() {
      this.showChatGptEnableModal = !this.showChatGptEnableModal
    },
    toggleDocSignatureEnableModal() {
      this.showDocSignatureEnableModal = !this.showDocSignatureEnableModal;
    },
    toggleFormsEnableModal() {
      this.showFormsEnableModal = !this.showFormsEnableModal;
    },
    onSettings() {
      if (this.integrationId === 'openai') {
        this.showDAssistanceSettings = true;
      } else if(this.integrationId === 'click_to_call'){
          this.showClick2CallSettings = true;

      }else {
        this.$router.push(
            this.frontendURL(
                `accounts/${this.accountId}/${this.integrationPath || 'settings/integrations'}/` + this.integrationId
            )
        );
      }
    },
    toggleDAssistanceShow() {
      this.showDAssistanceSettings = !this.showDAssistanceSettings
    },
    openDeletePopupApp() {
      this.deleteConfirmationTextApp.title = this.$t('INTEGRATION_APPS.DELETE.TITLE.ACCOUNT');
      this.deleteConfirmationTextApp.message = this.customTexts.deleteMessage || this.$t('INTEGRATION_APPS.DELETE.MESSAGE.ACCOUNT');
      this.showDeleteConfirmationPopup = true;

    },

    confirmDeletion() {
      if (this.integration.isApp) return this.deleteApp()

      this.closeDeletePopup();
      this.deleteIntegration(this.deleteIntegration);
      this.$router.push({name: 'settings_integrations'});
    },

    async addApp() {
      if (this.integrationId === 'openai') {
        this.showChatGptEnableModal = true;
        return;
      }
      if (this.integrationId === 'doc_signature') {
        this.showDocSignatureEnableModal = true;
        return;
      }
      if (this.integrationId === 'forms') {
        this.showFormsEnableModal = true;
        return;
      }
      if (this.integrationId === "click_to_call"){
        this.showChatClick2CallEnableModal = true;
        await Click2CallSettingsAPI.enableClick2Call();
      }
      try {
        await this.$store.dispatch('integrations/createHook', {
          app_id: this.integrationId,
          settings: {},
        });
        this.alertMessage = this.$t(
          'INTEGRATION_APPS.ADD.API.SUCCESS_MESSAGE',  {integrationName: this.integration.name}
        );
      } catch (error) {
        const errorMessage = error?.response?.data?.message;
        this.alertMessage =
          errorMessage || this.$t('INTEGRATION_APPS.ADD.API.ERROR_MESSAGE');
      } finally {
        this.showAlert(this.alertMessage);
      }
    },

    async deleteApp() {
      try {
        const selectedHook = this.integration.hooks[0];
        if(selectedHook.app_id === "click_to_call"){
          await Click2CallSettingsAPI.deleteSettings();
        }
        if (selectedHook.app_id === 'doc_signature') {
          await this.$store.dispatch('accounts/update', {
            additional_attributes: { document_signature_enabled: false },
          });
        }
        await this.$store.dispatch('integrations/deleteHook', {
          hookId: selectedHook.id,
          appId: selectedHook.app_id,
        });
        if (selectedHook.app_id === 'forms') {
          await this.$store.dispatch('accounts/setFormsEnabled', {
            accountId: this.accountId,
            enabled: false,
          });
        }
        this.alertMessage = this.$t(
          'INTEGRATION_APPS.DELETE.API.SUCCESS_MESSAGE'
        );
        this.closeDeletePopup();
      } catch (error) {
        const errorMessage = error?.response?.data?.message;
        this.alertMessage =
          errorMessage || this.$t('INTEGRATION_APPS.DELETE.API.ERROR_MESSAGE');
      } finally {
        this.showAlert(this.alertMessage);
      }
    },
  },
};
</script>
